module.exports = __webpack_public_path__ + "static/media/muscleaider-logo.e18364ef.jpg";